import Main from '@/components/main'
import Vue from 'vue'
import Router from 'vue-router'
import iView from 'view-design'
import store from '@/store'
import { setToken, getToken, canTurnTo, setUserToken, setOpenToken } from '@/libs/util'
require('babel-polyfill')
Vue.use(Router)
export const routes1 = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: true,
          title: '首页',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/single-page/home')
      },
      {
        path: '/error_logger_page',
        name: 'error_logger_page',
        meta: {
          title: '错误日志',
          icon: 'md-bug'
        },
        component: () => import('@/view/single-page/error-logger.vue')
      },
      {
        path: '/ownspace',
        name: 'ownspace',
        meta: {
          title: '个人中心',
          icon: 'md-bug'
        },
        component: () => import('@/view/single-page/own-space/index.vue')
      }
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/message',
    name: 'message',
    component: Main,
    meta: {
      hideInBread: true,
      hideInMenu: true
    },
    children: [
      {
        path: 'message_page',
        name: 'message_page',
        meta: {
          icon: 'md-notifications',
          title: '消息中心'
        },
        component: () => import('@/view/single-page/message')
      },
      {
        path: 'message_info',
        name: 'message_info',
        meta: {
          icon: 'md-notifications',
          title: '消息详情'
        },
        component: () => import('@/view/single-page/message/message-info')
      }
    ]
  }
]

const createRouter = () => new Router({
  routes: routes1,
  mode: 'history'
})

const router = createRouter()

const LOGIN_PAGE_NAME = 'login'

const turnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, store.getters.routes)) next() // 有权限，可访问
  else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
}

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach(async (to, from, next) => {
  iView.LoadingBar.start()
  const path = to.fullPath
  // let qqToken = path.split('&')[1]
  let qqToken = path.split('?')[1]
  if (qqToken) {
    qqToken = qqToken.substring(qqToken.indexOf('=') + 1)
    setToken(qqToken)
    setUserToken(qqToken)
  }
  const p = path.indexOf('?')
  if (p > 0) {
    const p1 = path.split('?')[0]
    to = {...to, ...{fullPath: p1, query: {}}}
  }
  const token = getToken()
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    next({
      name: LOGIN_PAGE_NAME
    })
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next() // 跳转
  } else {
    const length = store.getters.menuRspList.length
    if (length === 0) {
      const data = await store.dispatch('getMenuData')
      await store.dispatch('getUserInfo')
      if (data === null || data.length === 0) {
        setToken('')
        next({
          name: 'login'
        })
      }
      // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
      // 执行路由跳转方法
      router.addRoutes(store.getters.routesList)
      next({ ...to, replace: true })
    } else {
      turnTo(to, store.state.user.access, next)
    }
  }
})

export function resetRouter () {
  const newRoutes = createRouter()
  router.matcher = newRoutes.matcher
}

router.afterEach(to => {
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js